import React from 'react';
import Box from '@mui/material/Box';
import MDBox from 'components/MDBox';
import Card from '@mui/material/Card';
import SpedTab from './spedComponentTabs/SpedTab';

const SpedNotesComponent = () => {
  return (
    <>
      <MDBox>
        <Card>
          <MDBox mb={1}></MDBox>
          <Box>
            <SpedTab />
          </Box>
        </Card>
      </MDBox>
    </>
  );
};

export default SpedNotesComponent;
